const projectSourceListSingleflight = new WeakMap();

export function listProjectSourcesOnce(sourceAPI, projectId, sessionId = '') {
  const requestProjectId = String(projectId || '').trim();
  const requestSessionId = String(sessionId || '').trim();
  const requestKey = `${requestProjectId}::${requestSessionId}`;
  // Identical project IDs in independent Hosts must never share authenticated IO.
  const requests = projectSourceListSingleflight.get(sourceAPI) ?? new Map();
  projectSourceListSingleflight.set(sourceAPI, requests);
  let pendingRequest = requests.get(requestKey);
  if (!pendingRequest) {
    pendingRequest = sourceAPI.listProjectSources(requestProjectId, requestSessionId)
      .finally(() => {
        requests.delete(requestKey);
      });
    requests.set(requestKey, pendingRequest);
  }
  return pendingRequest;
}
